<template>
  <div>{{ this.sellers }}</div>
</template>

<script>
  import axios from 'axios'
  import { baseApiUrl, showError, userPayload } from '@/global'

  export default {
    name: 'Bonus',
    data: () => ({
      sellers: []
    }),
    methods: {
      getSellers() {
        const url = `${baseApiUrl}/sellers`
        axios
          .get(url)
          .then(res => {
            this.sellers = res.data
          })
          .catch(showError)
      }
    },
    mounted() {
      this.getSellers
    }
  }
</script>

<style></style>
